<i18n>
{
  "en": {
    "save": "Save",
    "title": "Blackboard Designer",
    "validationError": "You must add all grid items",
    "fullPreview": "Full preview"
  },
  "es": {
    "save": "Guardar",
    "title": "Diseñador de Pizarras",
    "validationError": "Se deben agregar todos los elementos en la plantilla",
    "fullPreview": "Preview completo"
  }
}
</i18n>
<template>
  <v-dialog
    v-model="visible"
    @click:outside="onCancel"
    fullscreen
  >
    <v-card v-if="gridConfiguration">
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="onCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t('title')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="align-center">
          <div v-if="!validationSave" class="validation-error">{{$t('validationError')}}</div>
          <v-btn
            dark
            text
            @click="onOpenFullPreview"
          >
            {{$t('fullPreview')}}
          </v-btn>
          <v-btn
            dark
            text
            @click="onSave"
            :disabled="!validationSave"
          >
            {{$t('save')}}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div class="d-flex mt-3 grid-content flex-wrap">
        <div class="grid-container">
          <GridGenerator />
        </div>
        <div>
          <GridForm :itemRequired="itemRequired"/>
        </div>
      </div>
    </v-card>
    <windows-portal
      class="wrapper"
      :open="openWindowPreviewPortal"
      :left="600"
      :top="20"
      :width="sizeWindowMap[aspectRatio].width"
      :height="sizeWindowMap[aspectRatio].height"
      @closed="closeWindowPreviewPortal"
    >
      <MenuRenderPreview v-if="selectedMenuForGrid" :menu="selectedMenuForGrid"/>
    </windows-portal>
  </v-dialog>
</template>
<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { Menu } from '@pointOfSale/models';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import GridGenerator from './components/gridGenerator.vue';
import GridForm from './components/gridForm.vue';
import MenuRenderPreview from './components/menuRenderPreview.vue';
import WindowsPortal from './components/windowsPortal.vue';

@Component
@Components({
  GridGenerator, GridForm, MenuRenderPreview, WindowsPortal
})
@MapActions(['selectedMenu', 'updateMenuGridConfiguration', 'clear', 'menuGridItemConfigurationRequest', 'setOpenPortal'])
@MapGetters(['gridConfiguration', 'validatedGridTemplate', 'gridTemplateArea', 'selectedGridItem', 'menuGridItemList', 'selectedMenuForGrid', 'selectedMenuForGrid', 'aspectRatio'])
export default class MenuGridGeneratorModal extends Vue {
  @Prop({ Boolean, default: false }) visible;

  @Prop({
    Object,
    validator(menu) {
      return menu instanceof Menu;
    },
  }) menu;

  openWindowPreviewPortal = false

  get validationSave() {
    const checkAllGridItems = this.menuGridItemList.filter((each) => this.gridTemplateArea.includes(each.name));
    return checkAllGridItems.length === this.menuGridItemList.length;
  }

  get itemRequired() {
    if (!this.validationSave) {
      const checkAllGridItems = this.menuGridItemList.filter((each) => !this.gridTemplateArea.includes(each.name));
      return checkAllGridItems.map((obj) => obj.guid);
    }
    return [];
  }

  get sizeWindowMap() {
    return {
      '16 / 9': { width: '1366', height: '768' },
      '9 / 16': { width: '567', height: '1008' },
      '4 / 3': { width: '1280', height: '960' },
      '3 / 2': { width: '1275', height: '850' },
      '21 / 9': { width: '1288', height: '552' },
      '1.85 / 11': { width: '90', height: '990' },
    };
  }

  onCancel() {
    this.clear();
    this.$emit('cancel');
  }

  onSave() {
    this.updateMenuGridConfiguration();
  }

  onOpenFullPreview() {
    this.openWindowPreviewPortal = false;
    this.$nextTick(() => {
      this.openWindowPreviewPortal = true;
    });
  }

  closeWindowPreviewPortal() {
    this.openWindowPreviewPortal = false;
  }

  @Watch('menu', { immediate: true })
  onMenuChanged(updatedMenu) {
    if (updatedMenu) {
      this.selectedMenu(updatedMenu);
    }
  }

  @Watch('selectedGridItem')
  async onSelectedGridItemChanged(updatedGridItem, oldGridItem) {
    if (updatedGridItem && updatedGridItem !== oldGridItem) {
      await this.menuGridItemConfigurationRequest(updatedGridItem.menuGridItemConfiguration);
    }
  }
}
</script>
<style scoped>
.grid-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 70%;
  position: relative;
  aspect-ratio: 16 / 9;
  margin: 10px;
}

.grid-content {
  justify-content: space-evenly;
}

.validation-error {
  color: red;
  font-size: 12px;
}
</style>
